export default __webpack_public_path__ + "static/media/operacionais.5f286585.svg";